var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.8205C0 22.1479 5.32174 28.241 12.2819 29.4765V18.8318H8.59732V14.7383H12.2819V11.4627C12.2819 7.77811 14.656 5.73195 18.0138 5.73195C19.0774 5.73195 20.2246 5.8953 21.2882 6.05865V9.8255H19.4054C17.6036 9.8255 17.1946 10.7258 17.1946 11.8729V14.7383H21.1248L20.4702 18.8318H17.1946V29.4765C24.1548 28.241 29.4765 22.1491 29.4765 14.8205C29.4765 6.66906 22.8443 0 14.7383 0C6.63221 0 0 6.66906 0 14.8205Z",
    fill: "#002E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8bed8187fdf718a22760ef5cf0a5e2e7.svg";
export { ForwardRef as ReactComponent };